<template>

	<div class="card">
		<div class="card-body">
			<drag-drop :uppy="uppy" class="mb-3"/>
			<div class="list-group list-group-flush">
				<div v-for="(file, index) in files" :key="file.id" class="list-group-item">
					<div class="row align-items-center">
						<div class="col">
							<h4 class="mb-1">{{ file.name }}</h4>
							<small class="text-muted">{{ formatBytes(file.size) }}</small>
						</div>
					</div><!--/.row-->
					<div class="row mt-3">
						<div class="col">
							<div class="progress progress-sm">
								<div class="progress-bar" role="progressbar"
									:style="'width: ' + file.progress.percentage + '%'"
									:aria-valuenow="file.progress.percentage"
									aria-valuemin="0" aria-valuemax="100"></div>
							</div>
						</div>
					</div><!--/.row-->
				</div>
			</div>
		</div>
	</div>

	<div v-if="creativeAssetMedia.length">

		<!-- Divider -->
		<hr class="mt-5 mb-5">

		<div v-for="(media, index) in creativeAssetMedia" :key="media.id">

			<agency-creator-media-card
				:media-data="media"
				:media-endpoint="this.mediaEndpoint"
			></agency-creator-media-card>

		</div>

	</div>

</template>


<script>
import Uppy from '@uppy/core';
import AwsS3Multipart from '@uppy/aws-s3-multipart';
import { DragDrop } from '@uppy/vue';

import AgencyCreatorMediaCard from './AgencyCreatorMediaCard.vue';

import '@uppy/core/dist/style.min.css';
import '@uppy/drag-drop/dist/style.min.css';
import '@uppy/progress-bar/dist/style.min.css';


export default {

	props: ['creator', 'project', 'mediaEndpoint'],

	components: {
		'drag-drop': DragDrop,
		'agency-creator-media-card': AgencyCreatorMediaCard
	},

	data() {
		return {
			creativeAssetMedia: [],
			files: [],
		}
	},

	mounted() {

		// register event listeners
		this.uppy.on('file-added', (file) => {
			console.log('Added file', file);
			this.files.push(file);
		});
		this.uppy.on('upload', (data) => {
			// data object consists of `id` with upload ID and `fileIDs` array
			// with file IDs in current upload
			// data: { id, fileIDs }
			console.log('upload', data);
		});
		this.uppy.on('upload-progress', (file, progress) => {
			for (var i = 0; i < this.files.length; i++)
			{
				// console.log('files[i]', this.files[i]);
				if(this.files[i].id == file.id) {
					this.files[i].progress.percentage = progress.bytesUploaded / progress.bytesTotal * 100;
				}
			}
		});
		this.uppy.on('upload-success', (file, response) => {
			// console.log('upload-success', file, response);
			this.handleUploadSuccess(file, response);
		});
		this.uppy.on('complete', (result) => {
			console.log('complete');
			console.log('successful files:', result.successful);
			console.log('failed files:', result.failed);
		});
		this.uppy.on('error', (error) => {
			console.log('error');
			console.error(error);
		});
		this.uppy.on('upload-error', (file, error, response) => {
			console.log('upload-error');
			console.log('error with file:', file.id);
			console.log('error message:', error);
		});

		this.fetchMedia();
	},

	computed: {
		uppy() {
			// initialize Uppy
			const uppy = new Uppy({
				// https://uppy.io/docs/uppy/
				id: 'uppy',
				autoProceed: true,
				allowMultipleUploadBatches: true,
				debug: true,
				inline: true,
				meta: {
					creatorId: this.creator.id,
					projectId: this.project.id,
				},
				restrictions: {
					allowedFileTypes: this.allowedFileTypes,
					maxFileSize: 1000 * 1000 * 1000 * 1000 * 2, /* 2 GB */
					maxNumberOfFiles: 20,
					minNumberOfFiles: 1,
				}
			}).use(AwsS3Multipart, {
				limit: 5,
				companionUrl: '/',
				companionHeaders:
				{
					'X-CSRF-TOKEN': window.csrfToken,
				},
			});

			return uppy;
		},
		allowedFileTypes() {
			return ['image/*', 'video/*', 'audio/*'];
		},
	},

	methods: {

		handleUploadSuccess(file, response) {

			// add file to media table in database
			axios.post(this.mediaEndpoint, {
				original_name: file.name,
				size: file.size,
				extension: file.extension,
				key: file.s3Multipart.key
			})
			.then((response) => {

				// add to beginning of media array
				this.creativeAssetMedia.unshift(response.data);

				// remove from files array
				for (var i = 0; i < this.files.length; i++)
				{
					if(this.files[i].id == file.id) {
						this.files.splice(i, 1);
					}
				}

			})
			.catch((error) => {
				console.error(error);
			});

		},

		// abortUpload(uploadId) {
		// 	axios.delete('/s3/multipart/' + uploadId)
		// 		.then((response) => {
		// 			console.log(response);

		// 			// remove from uploads array
		// 			for (var i = 0; i < this.uploads.length; i++)
		// 			{
		// 				if(this.uploads[i].id == uploadId) {
		// 					this.uploads.splice(i, 1);
		// 				}
		// 			}
		// 		})
		// 		.catch((error) => {
		// 			console.error(error);
		// 		});
		// },

		fetchMedia() {
			axios.get(this.mediaEndpoint)
				.then((response) => {
					this.creativeAssetMedia = response.data;
				})
				.catch((error) => {
					console.error(error);
				});
		},

		formatBytes(bytes, decimals = 0) {
			if (bytes === 0) return '0 bytes';
			const k = 1024;
			const dm = decimals < 0 ? 0 : decimals;
			const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
			const i = Math.floor(Math.log(bytes) / Math.log(k));
			return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
		},

		isLowRes(width, height) {
			if(width > 0 && height > 0 && (width * height < 1920 * 1080)) {
				return true;
			}
			else {
				return false;
			}
		},

		nl2br(str, is_xhtml) {
			var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />'   : '<br>';
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag   + '$2');
		}

	},

	beforeDestroy () {
		uppy.close()
	}
}

</script>
